var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('employee-volunteering-table'),_c('volunteer-opportunities'),_c('custom-alert'),_c('time-volunteering')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }